var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "breadcrumb",
    class: [("breadcrumb_" + (_vm.size)), {
      'breadcrumb_last-crumb': _vm.shrinkOnMobile
    }]
  }, [_c('nav', {
    staticClass: "breadcrumb__list"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "breadcrumb__item"
    }, [index !== _vm.formatList ? _c('nuxt-link', {
      staticClass: "breadcrumb__link",
      class: [{
        breadcrumb__link_icon: _vm.rootIcon && index === 0
      }],
      attrs: {
        "to": item.url
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('click');
        }
      }
    }, [_c('span', {
      staticClass: "breadcrumb__link-text"
    }, [_vm._v(_vm._s(item.name))])]) : _c('div', [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])], 1);
  }), 0), _vm._v(" "), _c('SearchSemantic', {
    attrs: {
      "data": {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': _vm.structuredList
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }